import React, { useState, useEffect, useCallback } from 'react';
import './Hero.css';

/* ─── Carousel slides ─── */
const slides = [
  {
    image: '/image/sanjaya.jpg',
    sub: "Greater Noida's #1 Real Estate Partner",
    word: 'Dream Home',
  },
  {
    image: '/image/san.jpg',
    sub: 'Premium Villas Near Jewar Airport',
    word: 'Premium Villa',
  },
  {
    image: '/image/sanj.jpg',
    sub: 'High-ROI Investment Opportunities',
    word: 'Smart Investment',
  },
];

const tabs    = ['Buy', 'Rent', 'Sell', 'Realtor selection'];
const filters = [
  { label: 'New home',      options: ['New home', 'Apartment', 'Villa', 'Farm Estate', 'Studio', 'Retail Shop'] },
  { label: '1, 2 rooms',   options: ['1, 2 rooms', '1 room', '2 rooms', '3 rooms', '4 rooms', '5+ rooms'] },
  { label: '₹30L – ₹1Cr', options: ['₹30L – ₹1Cr', 'Under ₹30 Lac', '₹30–60 Lac', '₹60L–1Cr', 'Above ₹1 Cr'] },
];

/* ─── Typewriter ─── */
function TypewriterWord({ word }) {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    setDisplayed('');
    let i = 0;
    const t = setInterval(() => {
      i++;
      setDisplayed(word.slice(0, i));
      if (i >= word.length) clearInterval(t);
    }, 75);
    return () => clearInterval(t);
  }, [word]);

  return (
    <span className="hero-typewriter">
      {displayed}
      <span className="hero-cursor">|</span>
    </span>
  );
}

export default function Hero() {
  const [slideIdx, setSlideIdx]   = useState(0);
  const [animating, setAnimating] = useState(false);
  const [activeTab, setActiveTab] = useState('Buy');
  const [selected, setSelected]   = useState(filters.map(f => f.options[0]));
  const [location, setLocation]   = useState('Greater Noida West');

  /* Auto-advance every 5 s */
  const goTo = useCallback((idx) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setSlideIdx(idx);
      setAnimating(false);
    }, 600);
  }, [animating]);

  useEffect(() => {
    const t = setInterval(() => {
      goTo((slideIdx + 1) % slides.length);
    }, 5000);
    return () => clearInterval(t);
  }, [slideIdx, goTo]);

  const handleFilter = (i, val) => {
    const u = [...selected];
    u[i] = val;
    setSelected(u);
  };

  const handleSearch = () => {
    const msg =
      `Hi! I'm looking for: ${activeTab} | Type: ${selected[0]} | Rooms: ${selected[1]} | Budget: ${selected[2]} | Location: ${location}`;
    window.open(`https://wa.me/917477471006?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const current = slides[slideIdx];

  return (
    <section className="hero-section">

      {/* ── CAROUSEL BACKGROUND ── */}
      <div className="hero-bg-image">
        {slides.map((s, i) => (
          <img
            key={s.image}
            src={s.image}
            alt={`slide-${i}`}
            className={`hero-slide-img ${i === slideIdx ? 'active' : ''} ${animating && i === slideIdx ? 'fade-in' : ''}`}
          />
        ))}
        <div className="hero-bg-gradient" />
      </div>

      {/* ── LEFT CONTENT ── */}
      <div className="hero-left-panel">

        <div className="hero-headline">
          <p className="hero-headline-sub animate-fade-up" style={{ animationDelay: '0.1s' }}>
            {current.sub}
          </p>
          <h1 className="hero-h1 animate-fade-up" style={{ animationDelay: '0.25s' }}>
            Find your<br />
            <TypewriterWord key={current.word} word={current.word} />
          </h1>
          <p className="hero-sub-desc animate-fade-up" style={{ animationDelay: '0.4s' }}>
            Explore premium 2BHK, 3BHK &amp; 4BHK villas, studio apartments
            and farm estates across Greater Noida West.
          </p>
        </div>

        {/* Search Box */}
        <div className="hero-search-card animate-fade-up" style={{ animationDelay: '0.55s' }}>
          <div className="hero-tabs">
            {tabs.map(t => (
              <button
                key={t}
                className={`hero-tab ${activeTab === t ? 'active' : ''}`}
                onClick={() => setActiveTab(t)}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="hero-filter-row">
            {filters.map((f, i) => (
              <React.Fragment key={i}>
                <div className="hero-filter-item">
                  <select
                    value={selected[i]}
                    onChange={e => handleFilter(i, e.target.value)}
                    aria-label={f.label}
                  >
                    {f.options.map(o => <option key={o}>{o}</option>)}
                  </select>
                  <i className="fa fa-chevron-down" />
                </div>
                {i < filters.length - 1 && <div className="hero-filter-sep" />}
              </React.Fragment>
            ))}
            <div className="hero-filter-sep" />
            <div className="hero-filter-item location-item">
              <i className="fa fa-location-dot location-icon" />
              <input
                type="text"
                value={location}
                onChange={e => setLocation(e.target.value)}
                placeholder="Location"
                aria-label="Location"
              />
            </div>
            <button className="hero-search-btn" onClick={handleSearch} aria-label="Search">
              <i className="fa fa-magnifying-glass" />
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="hero-stats-row animate-fade-up" style={{ animationDelay: '0.7s' }}>
          <div className="hero-stat-item"><strong>5+</strong><span>Projects</span></div>
          <div className="hero-vdiv" />
          <div className="hero-stat-item"><strong>₹23L</strong><span>Starting Price</span></div>
          <div className="hero-vdiv" />
          <div className="hero-stat-item"><strong>RERA</strong><span>Approved</span></div>
          <div className="hero-vdiv" />
          <div className="hero-stat-item"><strong>2400+</strong><span>Happy Clients</span></div>
        </div>
      </div>

      {/* ── CAROUSEL DOTS ── */}
      <div className="hero-carousel-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`hero-cdot ${i === slideIdx ? 'active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* ── PREV / NEXT ARROWS ── */}
      <button
        className="hero-arrow hero-arrow-prev"
        onClick={() => goTo((slideIdx - 1 + slides.length) % slides.length)}
        aria-label="Previous slide"
      >
        <i className="fa fa-chevron-left" />
      </button>
      <button
        className="hero-arrow hero-arrow-next"
        onClick={() => goTo((slideIdx + 1) % slides.length)}
        aria-label="Next slide"
      >
        <i className="fa fa-chevron-right" />
      </button>

      {/* Scroll indicator */}
      <div className="hero-scroll-indicator">
        <div className="scroll-mouse"><div className="scroll-wheel" /></div>
        <span>Scroll</span>
      </div>

    </section>
  );
}
